import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { useAccount } from 'wagmi';

import { OTC_DEFAULT_VALUES } from 'src/global/constants/otc.contant';
import { FormOTCValues } from 'src/global/types/otc.type';
import { useCreateOTCMutation, useDeleteOTCMutation } from 'src/store/services/otc.service';

import { OTCSchema, type OTCSchemaType } from './../global/schemas/otc.schema';

interface OTCForm {
  detail?: OTCSchemaType;
  programId?: string;
}
const useOtcSale = (props: OTCForm) => {
  const { detail, programId } = props;
  const { address } = useAccount();
  const navigate = useNavigate();
  const [createOtc, { isLoading: loadingCreateOtc }] = useCreateOTCMutation();
  const [deleteOtc, { isLoading: loadingDeleteOtc }] = useDeleteOTCMutation();
  const form = useForm<FormOTCValues>({
    resolver: zodResolver(OTCSchema),
    defaultValues: OTC_DEFAULT_VALUES,
    mode: 'onChange',
  });

  const convertTime = (time?: Date) => {
    return time ? new Date(time).toISOString() : undefined;
  };

  const handleCreateOtcSale = async () => {
    const values = form.getValues();
    const { startedTime, startedDate, closingTime, closingDate, ...rest } = values;
    const payload = {
      startedTime: convertTime(startedDate),
      startedDate: convertTime(startedDate),
      closingTime: convertTime(closingDate),
      closingDate: convertTime(closingDate),
      ...rest,
    };
    const res = await createOtc({ programId, payload: { ...(payload as any) }, creator: `${address}` });
    if (Number(res?.data?.code) === 200) {
      toast.success('OTC Sale created successfully');
      navigate(`/core-sale/${programId}`);
    } else {
      toast.error(res?.data?.message);
    }
  };

  const handleDeleteOtc = async () => {
    const res = await deleteOtc({ programId, creator: `${address}`, otcId: detail?.id });
    if (Number(res?.data?.code) === 200) {
      toast.success('OTC Sale deleted successfully');
      navigate(`/core-sale/${programId}`);
    } else {
      toast.error(res?.data?.message);
    }
  };

  useEffect(() => {
    if (detail) {
      form.reset({ ...detail });
    }
  }, [JSON.stringify(detail)]);

  return { form, isDetail: !!detail, handleCreateOtcSale, handleDeleteOtc, loadingCreateOtc, loadingDeleteOtc };
};

export default useOtcSale;
